import React, {useEffect, useState} from 'react'
import {css} from '@emotion/react'
import Hero from './Hero'
import FeaturesSection from './FeaturesSection'
import CtaSection from './CtaSection'
import ReviewsSection from './ReviewsSection'
import Footer from './Footer'
import FaqSection from './FaqSection'
import SuccessModal from './SuccessModal'
import {logSgc, setExtensionParamsToLocalStorage} from '../../../util/extensionMetadata'
import {useOnce} from '../../../util/customHooks'
import {EVENTS, logDplWithExtensionParams} from '../../../util/dpl'
import SEO from '../../seo'
import {getCountry} from '../../../util/getCountry'

const BrowserV1 = ({experimentId, os, browser, languageCode}) => {
    const [showSuccessModal, setShowSuccessModal] = useState(false)

    useOnce(() => {
        window.addEventListener('showSuccessModal', (e) => {
            const {ctaType} = e.detail
            logDplWithExtensionParams(EVENTS.StartpageBrowserInstallSuccess, {experiment: experimentId, type: ctaType})
            setShowSuccessModal(true)
        })
        window.addEventListener('hideSuccessModal', () => {
            setShowSuccessModal(false)
        })
        setExtensionParamsToLocalStorage(experimentId).then(() => {
            logDplWithExtensionParams(EVENTS.StartpagePageLoad, {
                os,
                browser,
                country: getCountry(),
                experiment: experimentId,
            })
            logSgc()
        })
    })

    return (
        <>
            <SEO
                title="Install Startpage Browser"
                description="The desktop browsing app is here. Simple. Stealth. Secure."
                ogImagePath="https://www.startpage.com/sp/cdn/images/startpage-shield.png"
            />
            <Hero experimentId={experimentId} os={os} browser={browser} languageCode={languageCode} />
            <FeaturesSection languageCode={languageCode} />
            <CtaSection experimentId={experimentId} ctaType="cta-3" languageCode={languageCode} />
            <ReviewsSection languageCode={languageCode} />
            <FaqSection languageCode={languageCode} />
            <CtaSection
                experimentId={experimentId}
                ctaType="cta-4"
                overrideStyles={css`
                    background: #fff;
                    .mask {
                        background-image: url(/images/hex2.png);
                    }
                `}
                os={os}
                browser={browser}
                languageCode={languageCode}
            />
            <Footer languageCode={languageCode} />
            <SuccessModal show={showSuccessModal} languageCode={languageCode} />
        </>
    )
}

export default BrowserV1
